export default {_name:'button.listItem',module:'Field',view:'Element/Button/ListItem',options:{xs:'auto',ms:'auto'},children:[]}